var InFlight = InFlight || {};
InFlight.NLX = InFlight.NLX || {};
InFlight.NLX.Utils = (function() {
  var _getProperties = function(data, name) {
    if (
      data &&
      data.CaptureResults &&
      data.CaptureResults[name] &&
      data.CaptureResults[name][0]
    ) {
      return data.CaptureResults[name][0].Properties;
    }

    return {};
  };

  var _propertyExists = function(data, name) {
    var prop = _getProperties(data, name);
    return (
      Object.keys(prop).length > 0 && (!prop.hidden || prop.hidden !== 'true')
    );
  };

  var _addToResponseData = function(data, name, props) {
    if (data && data.CaptureResults) {
      data.CaptureResults[name] = [
        {
          Children: null,
          Label: name,
          Properties: props
        }
      ];
    }
  };

  var _get = function(url) {
    var myconfig = {
      targetUrl: url,
      targetVerb: 'GET',
      followProposedTemplate: true,
      showLoading: true,
      manualRequestObj: [
        { Lbl: 'menuItems', Src: src, Data: content, Children: [] }
      ]
    };

    InFlightDC.init(myconfig);
  };

  var _setICAJAX = function(val) {
    _setHidden('ICAJAX', val);
  };

  var _setHidden = function (hiddenId, hiddenVal) {
    var $hidden = $('[id="'+hiddenId+'"]');
    if ($hidden.length != 1) {
      $hidden.remove();
      $hidden = $('<input/>', { id: hiddenId, name: hiddenId, type: 'hidden' });
      $hidden.insertAfter('input[type="hidden"]:last');
    }
    $hidden.val(hiddenVal);    
  }

  var _removeHidden = function (hiddenId) {
    var $hidden = $('[id="'+hiddenId+'"]');
    if ($hidden) {
      $hidden.remove();
    }
  }  

  var _getSubmitAction = function(href) {
    var regex = /javascript:submitAction_win.?\([^,]*,\S*'([^']*)'\S*\);/;
    var match = regex.exec(href);
    if (match) {
      return match[1];
    }
  };

  //ignoreKeys are the keys that disappeared in the partial response, that you want in the full response
  var _processPartialContent = function(
    data,
    sessionKey,
    conditionalObject,
    ignoreKeys,
    ignoreHiddenKeys
  ) {
    if (data && data.CaptureResults && sessionKey) {
      if (conditionalObject) {
        sessionStorage.setItem(sessionKey, JSON.stringify(data.CaptureResults));
      } else if (Object.keys(data.CaptureResults).length) {
        var cachedFullResponse = JSON.parse(sessionStorage.getItem(sessionKey));
        var partialKeys = Object.keys(data.CaptureResults);
        for (var i in partialKeys) {
          var key = partialKeys[i];
          if (ignoreKeys && ignoreKeys.indexOf(key) > -1) {
            continue;
          } else if (ignoreHiddenKeys && ignoreHiddenKeys.indexOf(key) > -1) {
            var ihkObject = data.CaptureResults[key];
            if (ihkObject[0].Properties.hidden) {
              continue;
            }
          }
          var captureResponse = data.CaptureResults[key];
          cachedFullResponse[key] = captureResponse;
        }
        
        data.CaptureResults = cachedFullResponse;
        sessionStorage.setItem(sessionKey, JSON.stringify(data.CaptureResults));
      }
    }
    return data;
  };

  var _processHideWhen = function() {
    var $hideWhen = $('[data-if-hide-when]');
    $hideWhen.each(function() {
      var $this = $(this);
      var hideWhenLabel = $this.data('if-hide-when');
      if (
        $(
          '[data-if-label="' +
            hideWhenLabel +
            '"]:not(.if-hide), [data-if-cloned-from="' +
            hideWhenLabel +
            '"]'
        ).length > 0
      ) {
        $this.show();
      } else {
        $this.hide();
      }
    });
  };

  var _getTargetUrlFromForm = function() {
    // this is set in nlx.fullscript.master
    return $('#formAction').attr('ifaction');
  };

  var _extractStrCurrUrl = function(scriptContent) {
    var strCurrRegex = /strCurrUrl='([^']*)';/;
    if (scriptContent) {
      var matches = strCurrRegex.exec(scriptContent);
      if (matches && matches.length > 0) {
        return matches[1];
      }
    }
  };

  return {
    props: _getProperties,
    addToResponseData: _addToResponseData,
    getSubmitAction: _getSubmitAction,
    propExists: _propertyExists,
    getTargetUrlFromForm: _getTargetUrlFromForm,
    processPartialContent: _processPartialContent,
    setICAJAX: _setICAJAX,
    setHidden: _setHidden,
    removeHidden: _removeHidden,
    processHideWhen: _processHideWhen,
    extractStrCurrUrl: _extractStrCurrUrl
  };
})();
